<template>
  <tr>
    <form-item-label label="お名前" :required="true" />
    <complemented-text-form
      v-if="complementedTextOpened"
      :text="complementedText"
      @open="openForm"
      :editable="false"
    />

    <td v-if="!complementedTextOpened" colspan="3">
      <div
        class="m3p-contact__input m3p-contact__input_2column m3p-contact__name"
      >
        <last-name-form
          :last-name="lastName"
          @change="(name, value) => changeValue(name, value)"
        />
        <first-name-form
          :first-name="firstName"
          @change="(name, value) => changeValue(name, value)"
        />
      </div>
    </td>
  </tr>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import ComplementedTextForm from '@component_path/pages/pc/positions/show/common_components/form_element/ComplementedText';
import FormItemLabel from '@component_path/pages/pc/positions/show/common_components/form_element/FormItemLabel';

import FirstNameForm from '@component_path/pages/pc/positions/show/inquiry_form/components/inquiry_form_item/FirstName';
import LastNameForm from '@component_path/pages/pc/positions/show/inquiry_form/components/inquiry_form_item/LastName';

const emit = defineEmits(['change']);

const props = defineProps({
  firstName: {
    type: String,
    required: false,
    default: ''
  },
  lastName: {
    type: String,
    required: false,
    default: ''
  },
  isLogged: {
    type: Boolean,
    required: true
  }
});

const complementedTextOpened = ref(false);

const complementedText = computed(() => `${props.lastName} ${props.firstName}`);

const changeValue = (key, newValue) => {
  emit('change', key, newValue);
  if (key === 'last_name') {
    emit('change', 'name', `${newValue} ${props.firstName}`);
  } else {
    emit('change', 'name', `${props.lastName} ${newValue}`);
  }
};

const openForm = () => {
  complementedTextOpened.value = false;
};

onMounted(() => {
  if (!!props.firstName && !!props.lastName) {
    complementedTextOpened.value = true;
  }
  if (!props.isLogged) {
    complementedTextOpened.value = false;
  }
});
</script>
